import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/new-cod.svg'
import _imports_1 from '@/app/ui/assets/svg/new-dfod.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-22dcee19")

_pushScopeId("data-v-22dcee19")
const _hoisted_1 = { class: "relative bg-gray-lp-1000 px-2 rounded pt-1 pb-2" }
const _hoisted_2 = { class: "text-12px xxl:text-14px text-gray-lp-300 font-semibold pb-1 text-left" }
const _hoisted_3 = {
  key: 0,
  class: "pt-1"
}
const _hoisted_4 = {
  key: 0,
  class: "delivery-service-logo",
  enabled: "",
  src: _imports_0,
  alt: "cod-logo-enabled"
}
const _hoisted_5 = {
  key: 1,
  class: "delivery-service-logo",
  enabled: "",
  src: _imports_1,
  alt: "dfod-logo-enabled"
}
const _hoisted_6 = { class: "flex text-16px font-semibold text-gray-lp-300" }
const _hoisted_7 = {
  key: 2,
  class: "ml-1"
}
const _hoisted_8 = { class: "border-b border-gray-lp-400" }
const _hoisted_9 = { class: "font-semibold text-14px p-4 text-gray-lp-300" }
const _hoisted_10 = { class: "px-4 cursor-pointer" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "text-14px font-medium text-gray-lp-300 col-span-3" }, " Tunai ", -1)
const _hoisted_12 = { class: "text-14px font-medium text-gray-lp-300 col-span-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Cash = _resolveComponent("Cash")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("bookingShipment.payment.title")), 1),
    (_ctx.isCreateBookingRetail && _ctx.isCOD)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          (_ctx.isCOD && !_ctx.isDFOD)
            ? (_openBlock(), _createBlock("img", _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.isDFOD)
            ? (_openBlock(), _createBlock("img", _hoisted_5))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.paymentMethodActive.name)
        ? (_openBlock(), _createBlock("button", {
            key: 1,
            tabindex: _ctx.showPaymentMethods ? -1 : 0,
            class: 
        `flex items-center ${
          _ctx.configShowPayment ? 'cursor-pointer' : ''
        } select-none rounded-md px-1`
      ,
            onMousedown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMouseDown = true)),
            onMouseup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMouseDown = false)),
            onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFocusTrigger && _ctx.onFocusTrigger(...args))),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.togglePaymentMethods && _ctx.togglePaymentMethods(...args))),
            disabled: !_ctx.configShowPayment,
            style: {"width":"164px"},
            id: _ctx.id
          }, [
            (_ctx.paymentMethodActive.name === 'cash')
              ? (_openBlock(), _createBlock(_component_Cash, {
                  key: 0,
                  class: "text-gray-lp-300 w-4 mr-2"
                }))
              : (_openBlock(), _createBlock("img", {
                  key: 1,
                  alt: "payment-logo",
                  class: "self-center w-4 mr-2",
                  src: 
          require(`@/app/ui/assets/svg/payment/${_ctx.paymentMethodActive.logo}2-active.svg`)
        
                }, null, 8, ["src"])),
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.accountIsNonForeign
            ? _ctx.paymentMethodActive.title
            : _ctx.$t("bookingShipment.payment.cash")), 1),
            (_ctx.accountIsNonForeign && _ctx.configShowPayment)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("img", {
                    alt: "",
                    class: "cursor-pointer select-none  w-4",
                    src: 
            require(`@/app/ui/assets/svg/${
              _ctx.showPaymentMethods ? 'chevron-up-new' : 'chevron-down-new'
            }.svg`)
          
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true)
          ], 42, ["tabindex", "disabled", "id"]))
        : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: "absolute border-l w-72 border-r flex flex-col bg-white rounded-lg shadow top-parent z-50",
      style: `margin-top: ${_ctx.isDiscount ? '50px' : '25px'};`
    }, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("bookingShipment.payment.choose")), 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("button", {
          ref: "paymentMethodCash",
          tabindex: _ctx.cashTabIndex,
          class: "flex flex-row gap-2 py-2 items-center w-full",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.payWithCash && _ctx.payWithCash(...args))),
          onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onKeydownPayCash && _ctx.onKeydownPayCash(...args)))
        }, [
          _createVNode(_component_Cash, { class: "text-red-lp-300 w-6 self-center" }),
          _hoisted_11
        ], 40, ["tabindex"]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (payment, index) => {
          return (_openBlock(), _createBlock("button", {
            key: index,
            tabindex: _ctx.paymentTabIndex,
            ref: `paymentMethodItem-${index}`,
            onClick: ($event: any) => (_ctx.payWithQr(payment)),
            onKeydown: ($event: any) => (_ctx.onItemKeydown($event, index)),
            class: "flex flex-row gap-2 py-2 items-center w-full"
          }, [
            _createVNode("img", {
              alt: "payment-logo",
              class: "self-center w-6",
              src: 
                require(`@/app/ui/assets/svg/payment/${payment.logo}2-active.svg`)
              
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_12, _toDisplayString(payment.title), 1)
          ], 40, ["tabindex", "onClick", "onKeydown"]))
        }), 128))
      ])
    ], 4), [
      [_vShow, _ctx.showPaymentMethods]
    ])
  ], 512)), [
    [_directive_click_outside, _ctx.forceClosePaymentMethods]
  ])
})